import React, { useState } from 'react';
import { InputField } from '../../../../components/Stepper/fields/inputField';
import { Dropdown } from 'primereact/dropdown';

const StructureForm = ({ onSubmit, groupsData }) => {
  const [structureData, setStructureData] = useState({
    name: '',
    inclusion: '',
  });

  const [formErrors, setFormErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length === 0) {
      onSubmit(structureData);
    } else {
      setFormErrors(errors);
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!structureData.name) errors.name = 'Name is required';
    if (!structureData.inclusion) errors.inclusion = 'Inclusion details are required';
    return errors;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setStructureData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    setFormErrors((prevErrors) => ({ ...prevErrors, [name]: '' }));
  };

  return (
    <>
      <h2 className="text-2xl font-semibold mb-6 text-secondary">General</h2>
      <form onSubmit={handleSubmit}>
        <div className="grid md:grid-cols-2 gap-5 text-primary mb-8">
          <InputField
            label="Name"
            placeholder="Enter your name"
            name="name"
            value={structureData.name}
            onChange={handleInputChange}
            errors={formErrors.name}
          />

          <div className="w-full">
            <label className="block mb-2 text-lg text-white font-semibold">Include In</label>
            <Dropdown
              value={structureData.inclusion}
              name="inclusion"
              onChange={handleInputChange}
              options={groupsData}
              optionLabel="name"
              placeholder="Select include In"
              className={`w-full bg-transparent border border-gray-300 rounded-lg ${structureData.inclusion ? "asset_Dropdown" : ""}`}

            />
            {formErrors.inclusion && <p className="text-red-500">{formErrors.inclusion}</p>}
          </div>

        </div>

        <div className='flex md:justify-end justify-center'>
          <button
            type="submit"
            className="px-6 py-2 text-primary bg-secondary hover:bg-secondary rounded-lg"
          >
            Submit
          </button>
        </div>
      </form>
    </>
  );
};

export default StructureForm;
